export default __webpack_public_path__ + "static/media/STLCoveringforVoting Results.0a58f303.pdf";